import React, { useState } from 'react';
import styled from '@emotion/styled';
import { ReactComponent as LocationIcon } from 'common/icons/location.svg';
import SelectEl from 'common/components/Select';
import MapExample from '../../images/map-example.png';

const InfoWrapper = styled.div`
  display:flex;
  flex-direction: column;
  padding: 16px;
  padding-right: 8px;
  position: relative;
  flex: 1 0 auto;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray};
`;

const MapWrapper = styled.div`
  display:flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  position: relative;
  min-width: 586px;
`;

type LocationProps = {
  title: string;
  date: string;
  coordinates?: string;
};

// locations: Одесса, вул. Люстдорфська 5; Одесса, вул. Академіка Корольова, 120; Одесса, вул. Рішельєвська, 27; Одесса, вул. Канатна, 55; Одесса, вул. Генерала Петрова, 51; Одесса, вул. Академіка Глушка, 14/4; Одесса, вул. Фонтанська дорога, 58/1; Одесса, вул. Люстдорфська дорога, 140/1; Одесса, вул. Фонтанська дорога, 20/4;

const LocationList: LocationProps[] = [
  {
    title: 'Одесса, вул. Люстдорфська 5',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Академіка Корольова, 120',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Рішельєвська, 27',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Канатна, 55',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Генерала Петрова, 51',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Академіка Глушка, 14/4',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Фонтанська дорога, 58/1',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Люстдорфська дорога, 140/1',
    date: 'Щодня з 9:00 до 20:00',
  },
  {
    title: 'Одесса, вул. Фонтанська дорога, 20/4',
    date: 'Щодня з 9:00 до 20:00',
  },
];
const LocationLine = ({ title, date }: LocationProps) => {
  return (
        <div className='account-info-location-line'>
            <LocationIcon className='svg-black svg-fill' height='16px' width='16px' />
            <div className='account-info-location-line-wrapper'>
                <span className='account-info-location-text'>{title}</span>
                <span className='account-info-location-text gray-text'>{date}</span>
            </div>
        </div>
  );
};

const cityData = [
  {
    label: 'Одеса',
    value: 1,
  },
];

export default function InfoPage() {
  const [city, setCity] = useState(1);
  const onChangeCity = (e) => {
    setCity(e.target.value);
  };
  return (
        <div className="account-info-section">
            <InfoWrapper>
                <div className='account-info-wrapper u-fancy-scrollbar'>
                    <span className='account-info-title'>Загальна інформація</span>
                    <span className='new-p account-info-description'>
                        KIMS - передовий сервіс з чистки та ремонту одягу і взуття в Україні. Будучи експертом №1 у сфері хімчистки та прання, маючи унікальну базу знань і досвіду, ми ділимося цим з іншими, розвиваючи свою франчайзингову мережу. Ми соціально активні. Філософії KIMS близька турбота про навколишнє середовище. Ми зробили наше виробництво максимально безвідходним, використовуємо еко технології та екологічні засоби для чищення. Пріоритет KIMS – найвищий ступінь задоволення клієнтів. Мета кожного співробітника нашої компанії – щоб ви залишилися задоволені, звернувшись до нас, і повернулися знову. Наша головна нагорода – ваше здивування і захоплення, коли ви розглядаєте свої готові замовлення і не вірите очам, тому що речі виглядають як нові.
                    </span>
                    <span className='account-info-title'>Веб-сайт</span>
                    <a style={{ marginBottom: '20px' }} className='basic-link' href='https://www.kims.com.ua'>https://www.kims.com.ua</a>
                    <span className='account-info-title'>Галузь</span>
                    <span style={{ marginBottom: '20px' }} className='new-p account-info-description'>
                        Хімчистка, ремонт, відновлення
                    </span>
                    <span className='account-info-title'>Країна</span>
                    <span style={{ marginBottom: '20px' }} className='new-p account-info-description'>
                        Україна
                    </span>
                    <span className='account-info-title'>Розмір компанії</span>
                    <span style={{ marginBottom: '20px' }} className='new-p account-info-description'>
                        1545 робітників
                    </span>
                </div>
            </InfoWrapper>
            <MapWrapper>
                <div className='account-map-wrapper'>
                    <span className='account-info-title'>Місце розташування</span>
                    <div className='account-info-map'>
                        <img src={MapExample} alt='map'/>
                        <div className='account-info-map-select'>
                            <SelectEl height='32px' value={city} onChange={onChangeCity} data={cityData} />
                        </div>
                    </div>
                    <div className='account-info-location-wrapper'>
                        <div className='account-info-location-list u-fancy-scrollbar'>
                            <span className='account-info-title'>Філіали</span>
                            {LocationList.map((location, index) => (
                                <LocationLine key={index} {...location} />
                            ))}
                        </div>
                    </div>
                </div>
            </MapWrapper>
        </div>
  );
}